import { DesignTheme } from '../types'
import { defaultTheme, defaultDarkTheme } from './default'

/**
 * Vivid — same structure as Default, violet accent identity.
 * Proves the token pipeline: swap `accent`/`inverse`, every themed
 * component (buttons, Stepper, ColorDot outlines, RoomPreview chrome)
 * re-skins with zero code changes since they read `--ds-accent` /
 * `--ds-inverse`, never a literal brand hex.
 */
export const vividTheme: DesignTheme = {
  ...defaultTheme,
  id: 'vivid',
  name: 'Vivid',
  color: {
    ...defaultTheme.color,
    accent: '#7C3AED',
    accentInk: '#FFFFFF',
    inverse: '#7C3AED',
    inverseInk: '#FFFFFF',
    hover: 'rgba(124, 58, 237, 0.08)',
  },
}

export const vividDarkTheme: DesignTheme = {
  ...defaultDarkTheme,
  id: 'vivid-dark',
  name: 'Vivid Dark',
  color: {
    ...defaultDarkTheme.color,
    accent: '#A78BFA',
    accentInk: '#0A0A0A',
    inverse: '#A78BFA',
    inverseInk: '#0A0A0A',
    hover: 'rgba(167, 139, 250, 0.12)',
  },
}
